import React, { useEffect, useState } from "react";
import { Box, Spinner, Flex, Text } from "@chakra-ui/react";
import { Line } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend, Filler } from "chart.js";
import axios from "axios";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend, Filler);

const API = process.env.REACT_APP_API_URL;

const ValidationTrend = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchHistory();
  }, []);

  const fetchHistory = async () => {
    try {
      const res = await axios.post(`${API}/validation/validation-history`, {});
      const rows = (res.data?.data || []).reverse(); // oldest first
      if (rows.length > 0) {
        setData({
          labels: rows.map((r) => {
            const d = new Date(r.run_date);
            return `${d.getDate()} ${["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"][d.getMonth()]}`;
          }),
          datasets: [
            {
              label: "Pass",
              data: rows.map((r) => r.total_pass),
              borderColor: "#12775F",
              backgroundColor: "rgba(56, 161, 105, 0.1)",
              fill: true,
              tension: 0.3,
              pointRadius: 4,
              pointHoverRadius: 6,
              borderWidth: 2,
            },
            {
              label: "Fail",
              data: rows.map((r) => r.total_fail),
              borderColor: "#BF3F38",
              backgroundColor: "rgba(229, 62, 62, 0.1)",
              fill: true,
              tension: 0.3,
              pointRadius: 4,
              pointHoverRadius: 6,
              borderWidth: 2,
            },
          ],
        });
      }
    } catch (err) {
      console.error("Failed to fetch validation history", err);
    } finally {
      setLoading(false);
    }
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { mode: "index", intersect: false },
    plugins: {
      legend: { position: "top", labels: { usePointStyle: true, padding: 20, font: { size: 12 } } },
      tooltip: {
        backgroundColor: "white",
        titleColor: "#333",
        bodyColor: "#666",
        borderColor: "#E2E8F0",
        borderWidth: 1,
        padding: 12,
        callbacks: {
          label: (ctx) => `${ctx.dataset.label}: ${ctx.raw} combinations`,
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        grid: { color: "rgba(0,0,0,0.05)", drawBorder: false },
        ticks: { font: { size: 11 }, color: "#A0AEC0" },
      },
      x: {
        grid: { display: false },
        ticks: { font: { size: 11 }, color: "#A0AEC0" },
      },
    },
  };

  if (loading) return <Flex justify="center" p={8}><Spinner size="lg" /></Flex>;
  if (!data) return <Text fontSize="sm" color="gray.500" textAlign="center" py={8}>No validation history yet. Data will appear after the first cron run.</Text>;

  return (
    <Box h="300px">
      <Line data={data} options={options} />
    </Box>
  );
};

export default ValidationTrend;
